export default __webpack_public_path__ + "static/media/pix.7041510c.svg";